import React, { useCallback, useState } from 'react';
import { Row, Col, Badge } from 'react-bootstrap';
import ReusableComponent from 'components/higerOreder/ReusableComponent';
import usePagination from 'hooks/usePagination';
import { useParams } from 'react-router';
import { API } from 'utils/Apiroutes';
import Useaxios from 'utils/Useaxios';
import CommonModal from 'components/ui/CommonModal';
import TableFilter from 'components/ui/TableFilter';
import { COLORS } from 'utils/theme';
import { showDeleteConfirmation, showSuccessAlert, showErrorAlert } from 'utils/swalAlert';
import '../../modalInput.css'
import { imageUrl } from 'utils/helper';

const SlotsPage = () => {
    const { machineId } = useParams();
    const { fetchData } = Useaxios();

    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [slotInputs, setSlotInputs] = useState([{ slotNumber: "" }]);
    const [showFilters, setShowFilters] = useState(false);
    const [editingSlot, setEditingSlot] = useState(null);
    const [products, setProducts] = useState([]);
    const [viewMode, setViewMode] = useState('table'); // 'table' or 'visual'
    const [editForm, setEditForm] = useState({
        slotNumber: '',
        productId: '',
        stock: 0,
        limit: 0
    });
    const [showProductModal, setShowProductModal] = useState(false);
    const [viewingProduct, setViewingProduct] = useState(null);

    const fetchSlots = useCallback(async (params) => {
        const res = await fetchData({
            url: API.getSlots(machineId),
            method: 'GET',
            params,
            showMessage: false
        });
        return res;
    }, []);

    const {
        data: AllSlots,
        loading,
        refresh,
        currentPage,
        totalPages,
        totalItems,
        pageSize,
        goToPage,
        nextPage,
        prevPage,
        changePageSize,
        filters,
        updateFilters,
        clearFilters
    } = usePagination(fetchSlots, {});
    console.log(AllSlots)

    const rows = AllSlots?.slots || [];

    // Fetch products for dropdown
    const fetchProducts = useCallback(async () => {
        try {
            const res = await fetchData({
                url: API.getProduct,
                method: 'GET',
                showMessage: false,
                params: {
                    limit: 1000
                }
            });
            if (res?.success) {
                setProducts(res.data.data || []);
            }
        } catch (error) {
            console.error('Failed to fetch products:', error);
        }
    }, []);

    React.useEffect(() => {
        fetchProducts();
    }, [fetchProducts]);

    const filterConfig = [
        { key: 'search', label: 'Slot Number', placeholder: 'Search by slot number...', icon: 'fas fa-hashtag' },


    ];

    // ----------- Slot Input Handlers ----------
    const addRow = () => {
        setSlotInputs([...slotInputs, { slotNumber: "" }]);
    };

    const updateRow = (index, value) => {
        const updated = [...slotInputs];
        updated[index].slotNumber = value;
        setSlotInputs(updated);
    };

    const removeRow = (index) => {
        if (slotInputs.length === 1) return;
        setSlotInputs(slotInputs.filter((_, i) => i !== index));
    };

    // ----------- EDIT SLOT ----------
    const handleEditSlot = (slot) => {
        console.log(slot)
        setEditingSlot(slot);
        setEditForm({
            slotNumber: slot.slotNumber,
            productId: slot.productId?._id || '',
            stock: slot.stock || 0,
            limit: slot.limit || 0
        });
        setShowEditModal(true);
    };

    const handleUpdateSlot = async () => {
        const payload = {
            machineId,
            slotId: editingSlot._id,
            slotNumber: editForm.slotNumber,
            stock: parseInt(editForm.stock) || 0,
            limit: parseInt(editForm.limit) || 0
        };

        try {
            const res = await fetchData({
                url: API.updateSlot(),
                method: "PUT",
                data: payload,
                showMessage: true
            });
            if (res?.success) {
                setShowEditModal(false);
                refresh();
                showSuccessAlert('Slot updated successfully.');
            }
        } catch (error) {
            showErrorAlert('Failed to update slot.');
        }
    };

    // ----------- VIEW PRODUCT ----------
    const handleViewProduct = (slot) => {
        if (slot.productId) {
            setEditingSlot(slot);
            setViewingProduct(slot.productId);
            setShowProductModal(true);
        }
    };

    // ----------- DELETE SLOT ----------
    const handleDeleteSlot = (slot) => {
        showDeleteConfirmation({
            title: 'Delete Slot?',
            text: 'You are about to delete slot',
            itemName: slot.slotNumber,
            onConfirm: async () => {
                try {
                    const res = await fetchData({
                        url: API.deleteSlot(),
                        method: "DELETE",
                        data: {
                            machineId: machineId,
                            slotId: slot._id
                        }
                    });
                    if (res?.success) {
                        refresh();
                        showSuccessAlert('Slot has been deleted successfully.');
                        fetchSlots()
                    }
                } catch (error) {
                    showErrorAlert('Failed to delete slot.');
                }
            }
        });
    };

    // ----------- API CALL TO CREATE SLOTS ----------
    const handleCreateSlots = async () => {
        const payload = {
            machineId,
            slots: slotInputs
        };

        const res = await fetchData({
            url: API.createSlots,
            method: "POST",
            data: payload,
            showMessage: true
        });

        if (res?.success) {
            setShowModal(false);
            refresh();
            setSlotInputs([{ slotNumber: "" }]);
        }
    };

    // Enhanced columns with custom rendering
    const enhancedColumns = [
        {
            label: "Slot No.",
            key: "slotNumber",
            render: (row) => (
                <div className="d-flex align-items-center">
                    <div className="slot-icon   text-light rounded-circle p-2 me-3" style={{ backgroundColor: COLORS.primary }}>
                        <i className="fas fa-hashtag"></i>
                    </div>
                    <h6 className="mb-0 fw-semibold">{row.slotNumber}</h6>
                </div>
            )
        },
        {
            label: "Product Assigned",
            key: "productId",
            render: (row) => (
                <div className="d-flex align-items-center">
                    {row.productId ? (
                        <>
                            <img
                                src={imageUrl(row?.productId?.image)}
                                alt={row.productId.name}
                                className="rounded me-3"
                                style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                            />
                            <div>
                                <div className="fw-medium">{row.productId.name}</div>
                                <small className="text-muted">ID: {row.productId._id.slice(-6)}</small>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="product-icon bg-secondary bg-opacity-10 text-secondary rounded-circle p-2 me-3">
                                <i className="fas fa-minus"></i>
                            </div>
                            <span className="text-muted">No Product</span>
                        </>
                    )}
                </div>
            )
        },
        {
            label: "Stock",
            key: "stock",
            render: (row) => (
                <div className="text-center">
                    <Badge
                        bg={row.stock < 5 ? 'danger' : row.stock < 10 ? 'warning' : 'success'}
                        className="rounded-pill px-3 py-2"
                    >
                        {row.stock || 0}
                    </Badge>
                </div>
            )
        },
        {
            label: "Limit",
            key: "limit",
            render: (row) => (
                <div className="text-center">
                    <span className="fw-medium">{row.limit || '—'}</span>
                </div>
            )
        },
        {
            label: "Status",
            key: "status",
            render: (row) => (
                <div className="text-center">
                    <Badge
                        bg={row.productId ? 'success' : 'secondary'}
                        className="rounded-pill px-3 py-2"
                    >
                        {row.productId ? 'Active' : 'Empty'}
                    </Badge>
                </div>
            )
        }
    ];

    const getSlotStats = () => {
        const withProduct = rows.filter(slot => slot.productId).length;
        const withoutProduct = rows.filter(slot => !slot.productId).length;
        const lowStock = rows.filter(slot => slot.stock < 5).length;
        return { withProduct, withoutProduct, lowStock, total: rows.length };
    };

    const slotStats = getSlotStats();

    const customHeader = rows.length > 0 ? (
        <div className="p-4 bg-light border-bottom">
            <Row className="g-3">
                <Col md={3}>
                    <div className="stat-card">
                        <div className="d-flex align-items-center">
                            <div className="stat-icon bg-primary bg-opacity-10 text-primary rounded-circle p-3 me-3">
                                <i className="fas fa-th-large fa-lg"></i>
                            </div>
                            <div>
                                <h3 className="fw-bold mb-0">{AllSlots?.totalSlots}</h3>
                                <small className="text-muted">Total Slots</small>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col md={3}>
                    <div className="stat-card">
                        <div className="d-flex align-items-center">
                            <div className="stat-icon bg-success bg-opacity-10 text-success rounded-circle p-3 me-3">
                                <i className="fas fa-box fa-lg"></i>
                            </div>
                            <div>
                                <h3 className="fw-bold mb-0">{AllSlots?.product}</h3>
                                <small className="text-muted">With Products</small>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col md={3}>
                    <div className="stat-card">
                        <div className="d-flex align-items-center">
                            <div className="stat-icon bg-warning bg-opacity-10 text-warning rounded-circle p-3 me-3">
                                <i className="fas fa-exclamation-triangle fa-lg"></i>
                            </div>
                            <div>
                                <h3 className="fw-bold mb-0">{AllSlots?.lowStock}</h3>
                                <small className="text-muted">Low Stock</small>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col md={3}>
                    <div className="stat-card">
                        <div className="d-flex align-items-center">
                            <div className="stat-icon bg-secondary bg-opacity-10 text-secondary rounded-circle p-3 me-3">
                                <i className="fas fa-minus-circle fa-lg"></i>
                            </div>
                            <div>
                                <h3 className="fw-bold mb-0">{AllSlots?.emptySlot}</h3>
                                <small className="text-muted">Empty Slots</small>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    ) : null;

    // Visual Vending Machine Component
    const VendingMachineVisual = () => {
        const sortedSlots = [...rows].sort((a, b) => {
            const aLetter = a.slotNumber.charAt(0);
            const bLetter = b.slotNumber.charAt(0);
            const aNumber = parseInt(a.slotNumber.slice(1));
            const bNumber = parseInt(b.slotNumber.slice(1));

            if (aLetter === bLetter) return aNumber - bNumber;
            return aLetter.localeCompare(bLetter);
        });

        const groupedSlots = sortedSlots.reduce((acc, slot) => {
            const row = slot.slotNumber.charAt(0);
            if (!acc[row]) acc[row] = [];
            acc[row].push(slot);
            return acc;
        }, {});

        return (
            <div className="vending-machine-container p-4">
                <div className="vending-machine" style={{
                    background: `linear-gradient(145deg, ${COLORS.primary}, ${COLORS.secondary})`,
                    borderRadius: '25px',
                    padding: '35px',
                    boxShadow: `0 25px 50px ${COLORS.primary}30`,
                    maxWidth: '900px',
                    margin: '0 auto',
                    border: '4px solid rgba(255,255,255,0.15)'
                }}>
                    <div className="machine-header text-center mb-4">
                        <h3 className="text-white mb-2">
                            <i className="fas fa-robot me-2"></i>
                            Vending Machine {machineId}
                        </h3>
                        <div className="machine-display" style={{
                            background: `linear-gradient(145deg, ${COLORS.dark}, ${COLORS.primary})`,
                            padding: '15px',
                            borderRadius: '12px',
                            border: `2px solid ${COLORS.info}`,
                            boxShadow: 'inset 0 2px 10px rgba(0,0,0,0.3)'
                        }}>
                            <div className="text-center">
                                <div className="text-white fw-bold mb-1">MACHINE STATUS</div>
                                <small className="text-light">Total: {rows.length} | Active: {slotStats.withProduct} | Empty: {slotStats.withoutProduct}</small>
                            </div>
                        </div>
                    </div>

                    <div className="slots-grid">
                        {Object.entries(groupedSlots).map(([rowLetter, rowSlots]) => (
                            <div key={rowLetter} className="slot-row mb-3">
                                <div className="row-label text-white fw-bold mb-2">
                                    Row {rowLetter}
                                </div>
                                <div className="d-flex flex-wrap gap-3 justify-content-center">
                                    {rowSlots.map((slot) => (
                                        <div
                                            key={slot._id}
                                            className="slot-item"
                                            style={{
                                                width: '150px',
                                                height: '180px',
                                                background: slot.productId ?
                                                    'linear-gradient(145deg, #ffffff, #f8f9fa)' :
                                                    `linear-gradient(145deg, ${COLORS.secondary}, #6c757d)`,
                                                borderRadius: '16px',
                                                padding: '16px',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                border: slot.productId ?
                                                    (slot.stock < 5 ? `2px solid ${COLORS.danger}` :
                                                        slot.stock < 10 ? `2px solid ${COLORS.warning}` :
                                                            `2px solid ${COLORS.success}`) :
                                                    '2px solid rgba(255,255,255,0.3)',
                                                position: 'relative',
                                                boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                                                overflow: 'hidden'
                                            }}
                                            onClick={() => handleEditSlot(slot)}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-8px)';
                                                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.2)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.12)';
                                            }}
                                        >
                                            {slot.productId ? (
                                                <>
                                                    {/* Header with Slot Number and Status */}
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <span className="badge" style={{
                                                            backgroundColor: COLORS.primary,
                                                            color: 'white',
                                                            fontSize: '11px',
                                                            fontWeight: 'bold',
                                                            padding: '4px 8px'
                                                        }}>
                                                            {slot.slotNumber}
                                                        </span>
                                                        <span className={`badge ${slot.stock < 5 ? 'bg-danger' : slot.stock < 10 ? 'bg-warning text-dark' : 'bg-success'}`} style={{
                                                            fontSize: '10px',
                                                            fontWeight: 'bold',
                                                            padding: '4px 6px'
                                                        }}>
                                                            {slot.stock}/{slot.limit}
                                                        </span>
                                                    </div>

                                                    {/* Product Image */}
                                                    <div className="text-center mb-3">
                                                        <div style={{
                                                            width: '80px',
                                                            height: '80px',
                                                            margin: '0 auto',
                                                            borderRadius: '12px',
                                                            overflow: 'hidden',
                                                            boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                                                            border: '2px solid #f1f3f4'
                                                        }}>
                                                            <img
                                                                src={imageUrl(slot.productId.image)}
                                                                alt={slot.productId.name}
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Product Name */}
                                                    <div className="text-center">
                                                        <div className="text-dark fw-semibold" style={{
                                                            fontSize: '12px',
                                                            lineHeight: '1.4',
                                                            height: '32px',
                                                            overflow: 'hidden',
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: 'vertical'
                                                        }}>
                                                            {slot.productId.name}
                                                        </div>
                                                    </div>

                                                    {/* Stock Progress Bar */}
                                                    <div className="mt-2">
                                                        <div className="progress" style={{ height: '4px', backgroundColor: '#e9ecef' }}>
                                                            <div
                                                                className="progress-bar"
                                                                style={{
                                                                    width: `${(slot.stock / slot.limit) * 100}%`,
                                                                    backgroundColor: slot.stock < 5 ? COLORS.danger : slot.stock < 10 ? COLORS.warning : COLORS.success
                                                                }}
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    {/* Empty Slot Header */}
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <span className="badge bg-light text-dark fw-bold" style={{
                                                            fontSize: '11px',
                                                            padding: '4px 8px'
                                                        }}>
                                                            {slot.slotNumber}
                                                        </span>
                                                        <span className="badge bg-secondary" style={{
                                                            fontSize: '10px',
                                                            padding: '4px 6px'
                                                        }}>
                                                            EMPTY
                                                        </span>
                                                    </div>

                                                    <div className="empty-slot text-center d-flex flex-column justify-content-center" style={{ height: '120px' }}>
                                                        <div className="mb-3" style={{
                                                            width: '60px',
                                                            height: '60px',
                                                            margin: '0 auto',
                                                            borderRadius: '50%',
                                                            backgroundColor: 'rgba(255,255,255,0.2)',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <i className="fas fa-plus text-white" style={{ fontSize: '24px', opacity: 0.8 }}></i>
                                                        </div>
                                                        <small className="text-white fw-semibold" style={{ opacity: 0.9, fontSize: '11px' }}>
                                                            Click to Add Product
                                                        </small>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="machine-footer mt-4 text-center">
                        <div className="status-lights d-flex justify-content-center gap-4">
                            <div className="status-light d-flex align-items-center bg-white bg-opacity-10 px-3 py-2 rounded-pill">
                                <div className="light rounded-circle me-2" style={{ width: '14px', height: '14px', background: COLORS.success, boxShadow: `0 0 10px ${COLORS.success}` }}></div>
                                <small className="text-white fw-semibold">Active: {slotStats.withProduct}</small>
                            </div>
                            <div className="status-light d-flex align-items-center bg-white bg-opacity-10 px-3 py-2 rounded-pill">
                                <div className="light rounded-circle me-2" style={{ width: '14px', height: '14px', background: COLORS.warning, boxShadow: `0 0 10px ${COLORS.warning}` }}></div>
                                <small className="text-white fw-semibold">Low Stock: {slotStats.lowStock}</small>
                            </div>
                            <div className="status-light d-flex align-items-center bg-white bg-opacity-10 px-3 py-2 rounded-pill">
                                <div className="light rounded-circle me-2" style={{ width: '14px', height: '14px', background: COLORS.secondary, boxShadow: `0 0 10px ${COLORS.secondary}` }}></div>
                                <small className="text-white fw-semibold">Empty: {slotStats.withoutProduct}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div>
            {/* View Toggle */}
            <div className="d-flex justify-content-between align-items-center mb-3 mt-2">
                <h4 className="mb-0">Slots Management - {machineId}</h4>
                <div className="btn-group" role="group">
                    <button
                        className={`btn ${viewMode === 'table' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setViewMode('table')}
                    >
                        <i className="fas fa-table me-2"></i>Table View
                    </button>
                    <button
                        className={`btn ${viewMode === 'visual' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => setViewMode('visual')}
                    >
                        <i className="fas fa-robot me-2"></i>Machine View
                    </button>
                </div>
            </div>

            {viewMode === 'visual' ? (
                <VendingMachineVisual />
            ) : (
                <ReusableComponent
                    title={`Slots Management - ${machineId}`}
                    data={rows}
                    columns={enhancedColumns}
                    loading={loading}
                    showActions={true}
                    onAddNew={() => setShowModal(true)}
                    addButtonText="Add New Slots"
                    icon="fas fa-th-large"
                    pagination={{
                        currentPage,
                        totalPages,
                        totalItems,
                        pageSize,
                        onPageChange: goToPage,
                        onNextPage: nextPage,
                        onPrevPage: prevPage,
                        onPageSizeChange: changePageSize
                    }}
                    filters={filters}
                    showFilters={showFilters}
                    onToggleFilters={() => setShowFilters(!showFilters)}
                    customFilters={
                        showFilters && (
                            <div className="px-3 pt-3 border-bottom">
                                <TableFilter
                                    filterConfig={filterConfig}
                                    filters={filters}
                                    onFilterChange={updateFilters}
                                    onClearFilters={clearFilters}
                                />
                            </div>
                        )
                    }
                    customHeader={customHeader}
                    emptyMessage="No slots found for this machine"
                    onEdit={(slot) => handleEditSlot(slot)}
                    onDelete={(slot) => handleDeleteSlot(slot)}
                    onView={(slot) => handleViewProduct(slot)}
                />
            )}

            {/* -------------------- MODAL --------------------- */}
            <CommonModal
                visible={showModal}
                title="Create Slots"
                onClose={() => setShowModal(false)}
                confirmText="Create"
                onConfirm={handleCreateSlots}
            >
                <div className="modalContainer">
                    <h6>
                        <i className="fas fa-plus-circle text-primary"></i>
                        Add New Slots
                    </h6>
                    {slotInputs.map((row, i) => (
                        <div key={i} className="modalInputGroup">
                            <input
                                type="text"
                                className="modalInput flex-grow-1"
                                placeholder="Enter slot number (e.g., A1, B2, C3)"
                                value={row.slotNumber}
                                onChange={(e) => updateRow(i, e.target.value)}
                            />
                            <button
                                className="modalRemoveBtn"
                                onClick={() => removeRow(i)}
                                title="Remove slot"
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    ))}
                    <button className="modalAddBtn" onClick={addRow}>
                        <i className="fas fa-plus"></i>
                        Add
                    </button>
                    <div className="text-muted">
                        Tip: Use alphanumeric format like A1, B2, C3 for easy identification
                    </div>
                </div>
            </CommonModal>

            {/* -------------------- EDIT MODAL --------------------- */}
            <CommonModal
                visible={showEditModal}
                title="Update Slot"
                onClose={() => setShowEditModal(false)}
                confirmText="Update"
                onConfirm={handleUpdateSlot}
            >
                <div className="modalContainer">
                    <h6>
                        <i className="fas fa-edit text-primary"></i>
                        Edit Slot Configuration
                    </h6>

                    <div className="row g-3">
                        <div className="col-12">
                            <label className="form-label fw-semibold text-dark mb-2">
                                <i className="fas fa-hashtag text-primary me-2"></i>
                                Slot Number
                            </label>
                            <input
                                type="text"
                                className="modalInput"
                                placeholder="Enter slot number (e.g., A1, B2)"
                                value={editForm.slotNumber}
                                onChange={(e) => setEditForm({ ...editForm, slotNumber: e.target.value })}
                            />
                        </div>

                        <div className="col-12">
                            <div className="d-flex align-items-center gap-3 mb-2">
                                <label className="form-label fw-semibold text-dark mb-0">
                                    <i className="fas fa-box text-success me-2"></i>
                                    Assigned Product
                                </label>
                                
                                <div
                                    className="modalInput d-flex align-items-center"
                                    style={{
                                        backgroundColor: "#f8f9fa",
                                        border: "1px solid #dee2e6",
                                        padding: "10px 12px",
                                        justifyContent: "flex-start",
                                        width: "200px"
                                    }}
                                >
                                    {editingSlot?.productId ? (
                                        <>
                                            <div className="fw-medium">{editingSlot.productId.name}</div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="product-icon bg-secondary bg-opacity-10 text-secondary rounded-circle p-2 me-3">
                                                <i className="fas fa-minus"></i>
                                            </div>
                                            <span className="text-muted">No Product Assigned</span>
                                        </>
                                    )}
                                </div>
                            </div>
                            
                            <small className="text-muted d-block">
                                Product assignment is fixed and cannot be changed
                            </small>
                        </div>


                        <div className="col-6">
                            <label className="form-label fw-semibold text-dark mb-2">
                                <i className="fas fa-cubes text-info me-2"></i>
                                Current Stock
                            </label>
                            <input
                                type="number"
                                className="modalInput"
                                placeholder="0"
                                value={editForm.stock}
                                onChange={(e) => {
                                    const newStock = parseInt(e.target.value) || 0;
                                    const currentLimit = parseInt(editForm.limit) || 0;
                                    if (currentLimit > 0 && newStock > currentLimit) {
                                        setEditForm({ ...editForm, stock: currentLimit });
                                    } else {
                                        setEditForm({ ...editForm, stock: e.target.value });
                                    }
                                }}
                                min="0"
                            />
                            <small className="text-muted mt-1 d-block">
                                Items currently in slot
                            </small>
                        </div>

                        <div className="col-6">
                            <label className="form-label fw-semibold text-dark mb-2">
                                <i className="fas fa-layer-group text-warning me-2"></i>
                                Maximum Limit
                            </label>
                            <input
                                type="number"
                                className="modalInput"
                                placeholder="0"
                                value={editForm.limit}
                                onChange={(e) => {
                                    const newLimit = parseInt(e.target.value) || 0;
                                    const currentStock = parseInt(editForm.stock) || 0;
                                    setEditForm({
                                        ...editForm,
                                        limit: e.target.value,
                                        stock: currentStock > newLimit ? newLimit : editForm.stock
                                    });
                                }}
                                min="0"
                            />
                            <small className="text-muted mt-1 d-block">
                                Maximum capacity of slot
                            </small>
                        </div>
                    </div>

                    <div className="alert alert-info mt-3 d-flex align-items-center">
                        <i className="fas fa-info-circle me-2"></i>
                        <small>
                            <strong>Tip:</strong> Stock should not exceed the limit. Leave product empty to make slot available for assignment.
                        </small>
                    </div>
                </div>
            </CommonModal>

            {/* View Product Details Modal */}
            <CommonModal
                visible={showProductModal}
                onClose={() => setShowProductModal(false)}
                title={
                  <div className="d-flex align-items-center text-white">
                    <div className="modal-icon bg-white bg-opacity-20 rounded-circle p-2 me-3">
                      <i className="fas fa-eye fa-lg"></i>
                    </div>
                    <div>
                      <h5 className="mb-0 fw-semibold">Product Details</h5>
                      <small className="opacity-75">Complete information about this product</small>
                    </div>
                  </div>
                }
                size="lg"
                showConfirm={false}
                cancelText="Close"
                customHeaderClass="modal-header-gradient"
              >
                {viewingProduct && (
                  <div className="p-4">
                    {/* Header Section */}
                    <div className="text-center mb-4">
                      <div className="product-image-large mb-3">
                        {viewingProduct.image ? (
                          <img
                            src={imageUrl(viewingProduct.image)}
                            alt={viewingProduct.name}
                            className="img-fluid rounded-3"
                            style={{ maxHeight: '180px', objectFit: 'contain', display: 'block' }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'flex';
                            }}
                            onLoad={(e) => {
                              e.target.style.display = 'block';
                              if (e.target.nextSibling) e.target.nextSibling.style.display = 'none';
                            }}
                          />
                        ) : null}
                        <div className="product-image-placeholder-large" style={{ display: viewingProduct.image ? 'none' : 'flex' }}>
                          <i className="fas fa-image fa-4x text-muted"></i>
                        </div>
                      </div>
                      <h3 className="fw-bold mb-2 text-dark">{viewingProduct.name}</h3>
                      <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mb-3">
                        <Badge bg="primary" className="rounded-pill px-3 py-2">
                          <i className="fas fa-hashtag me-2"></i>
                          ID: {viewingProduct._id?.substring(0, 8)}...
                        </Badge>
                        <Badge bg="info" className="rounded-pill px-3 py-2">
                          <i className="fas fa-tag me-2"></i>
                          {viewingProduct.categoryId?.name || 'No Category'}
                        </Badge>
                      </div>
                    </div>

                    <div className="divider mb-4">
                      <hr className="border-secondary opacity-25" />
                    </div>

                    {/* Product Details Grid */}
                    <Row className="g-3 mb-4">
                      <Col md={6}>
                        <div className="detail-card border-0 bg-light rounded-3 p-3 h-100">
                          <div className="d-flex align-items-center mb-2">
                            <div className="detail-icon bg-primary bg-opacity-10 text-primary rounded-circle p-2 me-3">
                              <i className="fas fa-dollar-sign"></i>
                            </div>
                            <div>
                              <small className="text-muted d-block">BASE PRICE</small>
                              <h6 className="mb-0 fw-bold text-dark">LRD{viewingProduct.basePrice}</h6>
                            </div>
                          </div>
                        </div>
                      </Col>
                      
                      <Col md={6}>
                        <div className="detail-card border-0 bg-light rounded-3 p-3 h-100">
                          <div className="d-flex align-items-center mb-2">
                            <div className="detail-icon bg-success bg-opacity-10 text-success rounded-circle p-2 me-3">
                              <i className="fas fa-boxes"></i>
                            </div>
                            <div>
                              <small className="text-muted d-block">STOCK QUANTITY</small>
                              <h6 className="mb-0 fw-bold text-dark">{viewingProduct.centralStock || 0} units</h6>
                            </div>
                          </div>
                        </div>
                      </Col>
                      
                      <Col md={6}>
                        <div className="detail-card border-0 bg-light rounded-3 p-3 h-100">
                          <div className="d-flex align-items-center mb-2">
                            <div className="detail-icon bg-warning bg-opacity-10 text-warning rounded-circle p-2 me-3">
                              <i className="fas fa-percentage"></i>
                            </div>
                            <div>
                              <small className="text-muted d-block">DISCOUNT</small>
                              <h6 className="mb-0 fw-bold text-dark">
                                {viewingProduct.isDiscounted ? `LRD${viewingProduct.discountValue}` : 'No Discount'}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </Col>
                      
                      <Col md={6}>
                        <div className="detail-card border-0 bg-light rounded-3 p-3 h-100">
                          <div className="d-flex align-items-center mb-2">
                            <div className="detail-icon bg-info bg-opacity-10 text-info rounded-circle p-2 me-3">
                              <i className="fas fa-money-bill-wave"></i>
                            </div>
                            <div>
                              <small className="text-muted d-block">FINAL PRICE</small>
                              <h6 className="mb-0 fw-bold text-success">
                                LRD{viewingProduct.isDiscounted ? viewingProduct.finalPrice : viewingProduct.basePrice}
                              </h6>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {/* Description */}
                    {viewingProduct.description && (
                      <div className="card border-0 bg-light rounded-3 p-4 mb-4">
                        <h6 className="fw-semibold text-dark mb-3">
                          <i className="fas fa-align-left text-primary me-2"></i>
                          Description
                        </h6>
                        <p className="mb-0 text-dark">{viewingProduct.description}</p>
                      </div>
                    )}

                    {/* Current Slot Assignment */}
                    <div className="card border-0 bg-light rounded-3 p-4">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="fw-semibold text-dark mb-0">
                          <i className="fas fa-th-large text-primary me-2"></i>
                          Current Slot Assignment
                        </h6>
                        <Badge bg="success" className="rounded-pill px-3 py-2">
                          <i className="fas fa-map-marker-alt me-1"></i>
                          Active
                        </Badge>
                      </div>
                      
                      <div className="border rounded-3 p-3 bg-white">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <div className="d-flex align-items-center">
                            <div className="bg-primary bg-opacity-10 text-primary rounded-circle p-2 me-3" style={{width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                              <i className="fas fa-square fa-lg"></i>
                            </div>
                            <div>
                              <h5 className="fw-bold mb-1">Slot {editingSlot?.slotNumber}</h5>
                              <small className="text-muted">Machine: {machineId}</small>
                            </div>
                          </div>
                          <div className="text-end">
                            <Badge bg="info" className="rounded-pill mb-1">
                              <i className="fas fa-boxes me-1"></i>
                              Stock: {editingSlot?.stock || 0}
                            </Badge>
                            <div>
                              <Badge bg="secondary" className="rounded-pill">
                                <i className="fas fa-layer-group me-1"></i>
                                Limit: {editingSlot?.limit || 0}
                              </Badge>
                            </div>
                          </div>
                        </div>
                        <div className="row g-2 mt-3">
                          <div className="col-6">
                            <div className="d-flex justify-content-between align-items-center">
                              <small className="text-muted">Machine ID:</small>
                              <small className="fw-medium">{machineId}</small>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between align-items-center">
                              <small className="text-muted">Slot Number:</small>
                              <small className="fw-medium">{editingSlot?.slotNumber}</small>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between align-items-center">
                              <small className="text-muted">Current Stock:</small>
                              <small className="fw-medium text-success">{editingSlot?.stock || 0} units</small>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="d-flex justify-content-between align-items-center">
                              <small className="text-muted">Max Capacity:</small>
                              <small className="fw-medium text-warning">{editingSlot?.limit || 0} units</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </CommonModal>
        </div>
    );
};

export default SlotsPage;